import styled, { css } from "styled-components";
import { Link as NextLink } from "next-view-transitions";

import STYLES from "@vita-learning/styles";

interface ButtonStyledProps {
	$color?: string;
	$pseudoColor?: string
}

const getButtonColor = ({ $color = STYLES.colors.vitas.primary }: ButtonStyledProps): string => $color;

const getButtonPseudoColor = ({ $pseudoColor = STYLES.colors.vitas.secondary }: ButtonStyledProps) => $pseudoColor;

export const buttonCss = css<ButtonStyledProps>`
	align-items: center;
	background-color: ${getButtonColor};
	border-color: transparent;
	border-radius: 0.33rem;
	color: white;
	cursor: pointer;
	display: flex;
	outline: none;
	justify-content: center;
	padding: 0.25rem 0.5rem;
	transition: background-color 0.5s ease;

	&:hover,
	&:focus,
	&:active {
		background-color: ${getButtonPseudoColor};
	}

	&:disabled {
		cursor: default;
		opacity: 0.75;

		&:hover {
			background-color: ${getButtonColor};
		}
	}
	
	&& {
		svg {
			color: white;
		}
	}

	@media screen and (${STYLES.breakpoints.desktop}) {
		border-radius: 0.5rem;
		font-size: 1.5rem;
		padding: 0.4rem 0.75rem;
	}
`;

export const ButtonBase = styled.button<ButtonStyledProps>`
	${buttonCss}
`;

export const LinkBase = styled(NextLink) <ButtonStyledProps>`
	${buttonCss}
	text-decoration: none;
`;